import { useState } from 'react'

import Hoja from './Hoja'
import { INTRO, VERSIONES, type Bloque, type Pieza } from '../lib/historial'

/**
 * El historial de versiones, que se abre tocando la version en Ajustes.
 *
 * Se pinta desplegable y no todo seguido: son diecisiete apartados y algunos
 * largos, asi que abierto de golpe habria que rodar media hoja para ver que
 * versiones hay. Empieza abierta **la que estas usando**, que es la que
 * contesta a la pregunta de por que se abre esto: que ha cambiado.
 */
function Trozo({ pieza }: { pieza: Pieza }) {
  if (pieza.tipo === 'fuerte') return <strong>{pieza.texto}</strong>
  if (pieza.tipo === 'enfasis') return <em>{pieza.texto}</em>
  if (pieza.tipo === 'codigo') return <code>{pieza.texto}</code>
  return <>{pieza.texto}</>
}

function Piezas({ piezas }: { piezas: Pieza[] }) {
  return (
    <>
      {piezas.map((pieza, indice) => (
        <Trozo key={indice} pieza={pieza} />
      ))}
    </>
  )
}

function Bloques({ bloques }: { bloques: Bloque[] }) {
  return (
    <>
      {bloques.map((bloque, indice) =>
        bloque.tipo === 'parrafo' ? (
          <p key={indice}>
            <Piezas piezas={bloque.piezas} />
          </p>
        ) : (
          <ul key={indice} className="historial-puntos">
            {bloque.puntos.map((punto, puesto) => (
              <li key={puesto}>
                <Piezas piezas={punto} />
              </li>
            ))}
          </ul>
        ),
      )}
    </>
  )
}

export default function Historial({ alCerrar }: { alCerrar: () => void }) {
  // Se abre el apartado de la version que estas usando, buscandolo por su
  // numero y no cogiendo el primero: si algun dia se publica algo sin apuntarlo
  // en el historial, o el historial se adelanta con lo que viene, el primero de
  // la lista no seria el tuyo. Si no aparece, se abre el mas reciente.
  const suyo = VERSIONES.find((version) => version.nombre === __VERSION__)
  const [abierta, setAbierta] = useState((suyo ?? VERSIONES[0])?.nombre ?? '')

  return (
    <Hoja titulo="Historial" nota="Que cambio en cada version" alCerrar={alCerrar}>
      {VERSIONES.map((version) => {
        const desplegada = version.nombre === abierta
        return (
          <div key={version.nombre} className="historial-version">
            <button
              type="button"
              className="historial-cabecera"
              aria-expanded={desplegada}
              onClick={() => setAbierta(desplegada ? '' : version.nombre)}
            >
              <span className="historial-numero">{version.nombre}</span>
              {version.fecha && <span className="meta">{version.fecha}</span>}
              <span className="historial-flecha">{desplegada ? '−' : '+'}</span>
            </button>
            {desplegada && (
              <div className="historial-cambios">
                <Bloques bloques={version.bloques} />
              </div>
            )}
          </div>
        )
      })}

      {INTRO.length > 0 && (
        <div className="historial-nota meta">
          <Bloques bloques={INTRO} />
        </div>
      )}
    </Hoja>
  )
}
